// Shared verbatim with grigora-admin/src/lib/acquisition-channel.js. Derive
// labels from retained evidence so old records benefit without rewriting history.
function channelFor(touch = {}) {
  const utm = touch.utm || {};
  const clicks = touch.click_ids || {};
  const source = (utm.utm_source || "").trim().toLowerCase();
  const medium = (utm.utm_medium || "").trim().toLowerCase().replace(/[ -]+/g, "_");
  const host = (touch.referring_domain || "").toLowerCase();
  const social = /(^|\.)(facebook\.com|instagram\.com|linkedin\.com|t\.co|twitter\.com|x\.com|reddit\.com|pinterest\.(com|co\.uk)|tiktok\.com|youtube\.com|youtu\.be|threads\.(net|com))$/.test(host) ||
    /^(facebook|instagram|meta|linkedin|twitter|x|reddit|pinterest|tiktok|youtube|threads)$/.test(source) ||
    /^(com\.facebook\.(katana|lite)|com\.instagram\.android|com\.linkedin\.android|com\.twitter\.android|com\.reddit\.frontpage|com\.zhiliaoapp\.musically)$/.test(host);
  if (["paid_social", "paidsocial"].includes(medium)) return "paid_social";
  if (["cpc", "ppc", "paidsearch", "paid_search"].includes(medium)) return social ? "paid_social" : "paid_search";
  if (medium === "email") return "email";
  if (medium === "affiliate") return "affiliate";
  if (["display", "cpm", "banner"].includes(medium)) return "display";
  if (["social", "social_media", "organic_social"].includes(medium)) return "organic_social";
  if (medium === "organic") return "organic_search";
  if (medium === "referral") return "referral";
  // These identify ad clicks; Google/Microsoft IDs don't establish placement.
  if (clicks.ttclid || clicks.twclid || clicks.li_fat_id) return "paid_social";
  if (clicks.gclid || clicks.gbraid || clicks.wbraid || clicks.msclkid) return "paid_other";
  // Meta attaches fbclid to unpaid links too. Paid/organic is unknown.
  if (clicks.fbclid) return "social_unknown";
  if (/(^|\.)(chatgpt\.com|chat\.openai\.com|perplexity\.ai|claude\.ai|gemini\.google\.com|copilot\.microsoft\.com|grok\.com)$/.test(host) || /^(chatgpt(?:\.com)?|perplexity(?:\.ai)?|claude(?:\.ai)?|gemini|copilot|grok)$/.test(source)) return "ai_referral";
  if (source || medium || Object.values(utm).some(Boolean)) return "campaign_other";
  // An Android Google-app visit may be Search or Discover, so don't guess which.
  if (host === "com.google.android.googlequicksearchbox") return "google_app";
  if (/(^|\.)(google\.(com|cat|[a-z]{2}|com\.[a-z]{2}|co\.[a-z]{2})|bing\.com|duckduckgo\.com|search\.yahoo\.com|search\.brave\.com|baidu\.com|yandex\.(com|ru|[a-z]{2})|ecosia\.org|search\.aol\.com|startpage\.com)$/.test(host)) return "organic_search";
  if (social) return "organic_social";
  if (host) return "referral";
  return "direct_or_unknown";
}

function sourceFor(touch = {}) {
  if (touch.utm?.utm_source) return touch.utm.utm_source;
  const clicks = touch.click_ids || {};
  if (clicks.gclid || clicks.gbraid || clicks.wbraid) return "Google Ads";
  if (clicks.msclkid) return "Microsoft Ads";
  if (clicks.ttclid) return "TikTok Ads";
  if (clicks.twclid) return "X Ads";
  if (clicks.li_fat_id) return "LinkedIn Ads";
  if (clicks.fbclid) return "Meta link (paid or organic unknown)";
  if (touch.referring_domain === "com.google.android.googlequicksearchbox") return "Google app (Search or Discover)";
  return touch.referring_domain || "";
}
module.exports = { channelFor, sourceFor };
